import { Base } from '@studiometa/js-toolkit';
import TableOfContentAnchorFrieze from './TableOfContentAnchorFrieze.js';
import AnchorScrollToHorizontal from '../atoms/AnchorScollToHorizontal.js';

/**
 * TableOfContentFrieze component
 */
export default class TableOfContentFrieze extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'TableOfContentFrieze',
    components: {
      TableOfContentAnchorFrieze,
      AnchorScrollToHorizontal,
    },
  };

  /**
   * onAnchorScrollToHorizontalEnter
   */
  onAnchorScrollToHorizontalEnter() {
    this.$children.TableOfContentAnchorFrieze.forEach((item) => {
      item.$refs.text.classList.add('is-hidden');
    });
  }

  /**
   * onAnchorScrollToHorizontalLeave
   */
  onAnchorScrollToHorizontalLeave() {
    this.$children.TableOfContentAnchorFrieze.forEach((item) => {
      item.$refs.text.classList.remove('is-hidden');
    });
  }
}
